module.exports = __webpack_public_path__ + "img/chinese-kip-met-tomatensaus.9f9959e5.jpeg";